import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import LatestMovies from "./components/LatestMovies";
import PopularRanking from "./components/PopularRanking";
import NewsPreview from "./components/NewsPreview";
import SiteLayout from "@/components/feature/SiteLayout";
import usePageMeta from "@/hooks/usePageMeta";
import { Link } from "react-router-dom";

export default function Home() {
  usePageMeta(
    "日韩黄色电影 - 日韩情色影视资源与资讯平台",
    "日韩黄色电影提供丰富的日韩情色电影资源与相关资讯，涵盖多种影视题材，满足用户多样化观看和了解需求。",
    "日韩黄色电影,日韩情色电影,日韩成人电影,情色影视,日韩电影资源,影视资讯,日韩影视平台",
  );

  return (
    <SiteLayout>
      <HeroCarousel />
      <CategoryShortcuts />
      <LatestMovies />
      <PopularRanking />
      <NewsPreview />

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
        <div className="w-full max-w-[1400px] mx-auto relative overflow-hidden rounded-lg bg-primary-500 px-6 md:px-12 py-10 md:py-14">
          <div className="absolute -right-10 -top-16 w-64 h-64 rounded-full bg-background-50/10" />
          <div className="absolute -right-24 bottom-0 w-52 h-52 rounded-full bg-background-50/5" />
          <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-6">
            <div className="max-w-[600px]">
              <p className="font-label text-[11px] tracking-[0.26em] uppercase text-accent-300">
                Start Exploring
              </p>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl leading-snug text-foreground-950">
                找到今晚想看的那一部
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-950/80">
                用地区、年代、片长与题材标签组合筛选，或直接搜索导演与片名。
                站内所有条目均为演示内容，不含任何播放与下载地址。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 shrink-0">
              <Link
                to="/category/popular"
                className="h-11 px-6 rounded-md bg-background-50 text-foreground-900 text-sm flex items-center justify-center gap-2 cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-compass-3-line" />
                进入片库
              </Link>
              <Link
                to="/faq"
                className="h-11 px-6 rounded-md border border-foreground-950/30 text-foreground-950 text-sm flex items-center justify-center gap-2 cursor-pointer hover:border-foreground-950/70 transition-colors whitespace-nowrap"
              >
                常见问题
              </Link>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}